/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Directive, ElementRef, OnInit, Renderer2, inject} from '@angular/core';
import {OrganizationLogo, OrganizationLogoDetails} from '../models/FeatureFlag';
import {FeatureFlaggingService} from '../services/feature-flagging.service';
import {themeSwitcher} from '@siemens/ix-angular';
import {AppSettings} from '../models/Constants';
import {ThemeService} from '../services/theme.service';

@Directive({
  selector: '[appFeatureFlagImage]',
  standalone: false,
})
export class FeatureFlagImageDirective implements OnInit {
  private readonly el = inject(ElementRef);
  private readonly featureFlaggingService = inject(FeatureFlaggingService);
  private readonly renderer = inject(Renderer2);
  private readonly themeService = inject(ThemeService);

  organizationLogo?: OrganizationLogo;

  ngOnInit(): void {
    this.featureFlaggingService.load().then((features) => {
      if (features.organizationLogo) {
        this.organizationLogo = features.organizationLogo;
        if (this.themeService.actualVariant === 'dark') {
          this.updateImage(this.organizationLogo.darkTheme);
        } else {
          this.updateImage(this.organizationLogo.lightTheme);
        }
      }
    });

    themeSwitcher.schemaChanged.on(() => {
      if (this.organizationLogo) {
        if (this.themeService.actualVariant === 'dark') {
          this.updateImage(this.organizationLogo.darkTheme);
        } else {
          this.updateImage(this.organizationLogo.lightTheme);
        }
      }
    });
  }

  private updateImage(organizationLogo: OrganizationLogoDetails): void {
    sessionStorage.setItem(
      AppSettings.ORGANIZATION_LOGO_NAME,
      organizationLogo.data,
    );
    this.renderer.setAttribute(
      this.el.nativeElement,
      'src',
      `data:${organizationLogo.type};base64,${organizationLogo.data}`,
    );

    this.renderer.setAttribute(
      this.el.nativeElement,
      'alt',
      'organization-logo',
    );
    this.renderer.setAttribute(
      this.el.nativeElement,
      'height',
      organizationLogo.height.toString(),
    );
    this.renderer.setAttribute(
      this.el.nativeElement,
      'width',
      organizationLogo.width.toString(),
    );
    this.renderer.setAttribute(
      this.el.nativeElement,
      'id',
      'featureFlagOrganisationLogo',
    );
  }
}
